import { useTranslation } from "react-i18next";
import BackButton from "../../components/button/BackButton";
import { Button } from "../../components/button";
import { APP_ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchBlacklistVisitorsCard from "../../components/card/SearchBlacklistVisitorsCard";
import SearchBlacklistVisitorsTable from "../../components/table/SearchBlacklistVisitorsTable";
import { PAGE_SIZE } from "../../constants/common";

const SearchBlacklistVisitors = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);

  const [search, setSearch] = useState("");

  const [allVisitors, setAllVisitors] = useState([]);

  return (
    <div className="flex flex-col lg:gap-2">
      <div className="flex flex-col gap-4 md:gap-8">
        <div className="flex items-center justify-between">
          <h1 className="text-xl md:text-2xl dark:text-white">
            {t("searchBlacklistVisitors")}
          </h1>
          <div className="flex items-center gap-2">
            <Button
              type="button"
              onClick={() => navigate(APP_ROUTES.ADD_BLACKLIST_VISITOR)}
              className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:!ring-white dark:text-white"
            >
              {t("addBlacklistVisitor")}
            </Button>
            <BackButton />
          </div>
        </div>

        <SearchBlacklistVisitorsCard
          setAllVisitors={setAllVisitors}
          page={page}
          search={search}
          setPages={setPages}
          setCount={setCount}
          pageSize={pageSize}
        />

        <SearchBlacklistVisitorsTable
          allVisitors={allVisitors}
          page={page}
          pages={pages}
          setPage={setPage}
          search={search}
          setSearch={setSearch}
          count={count}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default SearchBlacklistVisitors;
